import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';

function List() {

    const pathFrontEnd = '/courtauditorscategories/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}courtauditorscategories/delete`,
        endpoint: config.endpoints.backend + 'courtauditorscategories/getalllist'
    }

    let list = {
        labelTitle: 'Lista de Tipos do tribunal de contas',
        labelTitleButtonAdd: 'Incluir novo tipo do tribunal de contas',
        fieldsShowOnDelete: ['description'],
        showPrintButtons: true,
        columns: [
            {
                name: 'description',
                label: 'Nome'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
